import styled from 'styled-components';

import { Flex, spaceMixin, token } from '@zillow/constellation';

export const StyledFlexContainer = styled(Flex)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: ${spaceMixin('sm')};
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${token('colors.gray300')};
`;
